import { render, staticRenderFns } from "./ResetPasswordCard.vue?vue&type=template&id=1a513ee8&scoped=true&"
import script from "./ResetPasswordCard.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordCard.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordCard.vue?vue&type=style&index=0&id=1a513ee8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a513ee8",
  null
  
)

export default component.exports